var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service-form-part"},[_c('DormerMaterialRadioField',_vm._g({ref:"dormerMaterial",attrs:{"choices":_vm.choices}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }